import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { PasswordExpiringBanner, PasswordExpiredGate, useAuth } from '../features/auth';
import { passwordChangeRequired } from '../features/auth/passwordGate';
import { UrgentAnnouncementGate } from '../features/announcements';
import { Sidebar } from './Sidebar';
import { LicenseReadOnlyBanner } from '../features/license/LicenseReadOnlyBanner';
import { useIsMobile } from '../shared/hooks/useIsMobile';
import { InboxBadgesProvider } from '../features/whatsapp/contexts/InboxBadgesContext';
import styles from './AppLayout.module.css';

const COLLAPSED_KEY = 'gaia.sidebar.collapsed';

export function AppLayout() {
  const isMobile = useIsMobile();
  const { userDoc } = useAuth();
  const [mountTime] = useState(() => Date.now());
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(COLLAPSED_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch {
      /* degrade silencioso */
    }
  }, [collapsed]);

  function handleToggleSidebar(): void {
    if (isMobile) {
      setMobileOpen((v) => !v);
    } else {
      setCollapsed((v) => !v);
    }
  }

  return (
    <InboxBadgesProvider>
      <div className={styles.shell}>
        <TopBar onToggleSidebar={handleToggleSidebar} />
        <PasswordExpiringBanner />
        <LicenseReadOnlyBanner />
        <div className={styles.body}>
          {!isMobile ? (
            <Sidebar
              collapsed={collapsed}
              onToggleCollapsed={() => setCollapsed((v) => !v)}
              isMobile={false}
              mobileOpen={false}
              onCloseMobile={() => undefined}
            />
          ) : null}
          <main className={styles.main}>
            <Outlet />
          </main>
        </div>
        {isMobile ? (
          <Sidebar
            collapsed={false}
            onToggleCollapsed={() => undefined}
            isMobile
            mobileOpen={mobileOpen}
            onCloseMobile={() => setMobileOpen(false)}
          />
        ) : null}
        <PasswordExpiredGate />
        {passwordChangeRequired(userDoc, mountTime) ? null : <UrgentAnnouncementGate />}
      </div>
    </InboxBadgesProvider>
  );
}
